<template>
  <!-- 基础信息 -->
  <div class="base-info-wrapper">
    <!-- 商品信息 -->
    <el-descriptions style="margin-bottom:20px;" direction="vertical" :column="10" border>
      <el-descriptions-item label="订单号" :span="2" label-class-name="my-label">
        {{ $route.params.id }}
        <el-tag type="primary" v-if="detail.orderType == 1" size="mini">普通订单 </el-tag>
        <el-tag type="warning" v-if="detail.orderType == 2" size="mini">门店订单 </el-tag>
      </el-descriptions-item>
      <template v-if="detail.orderGoods">
        <el-descriptions-item label="商品描述" :span="3" label-class-name="my-label">
          <div class="handle">
            <span>
              {{ detail.orderGoods.skuTitle }}
              <el-tag :type="detail.orderGoods.goodsPurityName == '全新' ? 'primary' : 'warning'" size="mini">
                {{ detail.orderGoods.goodsPurityName }}
              </el-tag>
            </span>
          </div>
        </el-descriptions-item>
      </template>
      <el-descriptions-item label="门店信息" :span="2" label-class-name="my-label">
        {{ detail.store ? detail.store.storeName : '' }}
      </el-descriptions-item>
      <el-descriptions-item label="订单状态" :span="1" label-class-name="my-label">
        {{ detail.orderStatusName }}
      </el-descriptions-item>
      <el-descriptions-item label="下单时间" :span="2" label-class-name="my-label">
        {{ detail.orderCreateTime }}
      </el-descriptions-item>
      <!-- 第二排 -->
      <el-descriptions-item label="费率" :span="1" label-class-name="my-label">
        {{ detail.priceRate }} %
      </el-descriptions-item>
      <el-descriptions-item label="平台服务费" :span="1" label-class-name="my-label">
        {{ detail.servicePrice }}
      </el-descriptions-item>
      <el-descriptions-item label="保险金" label-class-name="my-label">
        {{ detail.insurancePrice }}
      </el-descriptions-item>
      <el-descriptions-item label="溢价金" :span="1" label-class-name="my-label" content-class-name="my-content">
        <div class="handle">
          <span>{{ detail.overflowPrice }}</span>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="零售价" :span="1" label-class-name="my-label">
        <div class="handle">
          <span>{{ detail.salePrice }}</span>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="首付租金" :span="1" label-class-name="my-label">
        {{ detail.prepayRentPrice }}
        <el-tag type="primary" v-if="detail.prepayPayMode == 'member:offline'" size="mini">线下支付</el-tag>
        <el-tag type="success" v-if="detail.prepayPayMode != '' && detail.prepayPayMode != 'member:offline'" size="mini"
          >线上支付
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="租期" :span="1" label-class-name="my-label">
        {{ detail.billPeriodNum }} 期
      </el-descriptions-item>
      <el-descriptions-item label="总租金" :span="1" label-class-name="my-label">{{ detail.rentPrice }}</el-descriptions-item>
      <el-descriptions-item label="买断金" :span="1" label-class-name="my-label">{{ detail.buyoutPrice }}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      periodDialog: false,
      priceData: {
        salePrice: '',
        orderNo: ''
      }
    }
  },
  computed: {
    // 零售价显示，已废弃
    is_show() {
      const { status } = this.detail
      const status_arr = [2, 5, 6, 7, 91, 92, 93]
      const res = status_arr.indexOf(status)
      return res == -1 ? false : true
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.base-info-wrapper /deep/ {
  width: 100%;
  .el-descriptions {
    .my-label {
      color: #1a1e25;
      background: #fafafa;
    }
    .handle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      & > span {
        &:first-child {
          margin-right: 20px;
          flex: 1;
        }
      }
    }
  }
}
</style>
